import React from "react";
import { Slider, Input, Alert } from "antd";
import { connect } from "react-redux";
import "assets/stylesheets/SelectAtar.scss";
import { parsePositiveInteger, MIN_ATAR } from "utils/generalHelpers";

class SelectAtar extends React.Component {
  state = {
    lowAtar: false,
  };

  onSliderChange = (value) => {
    this.props.dispatch({
      type: "ATAR_UPDATED",
      data: { atar: value },
    });
  };
  onInputChange = (e) => {
    const { value } = e.target;
    const sanitizedValue = parsePositiveInteger(value);
    if (sanitizedValue && sanitizedValue < MIN_ATAR) {
      this.setState({ lowAtar: true });
    } else {
      this.setState({ lowAtar: false });
    }
    this.props.dispatch({
      type: "ATAR_UPDATED",
      data: { atar: sanitizedValue },
    });
  };

  getMarks = () => {
    const { atar } = this.props;
    const marks = {
      26: <div className="slider-mark">{`<30`}</div>,
      96: <div className="slider-mark">{`>95`}</div>,
    };
    let displayedMark;
    if (atar <= 26) {
      displayedMark = "<30";
    } else if (atar >= 96) {
      displayedMark = ">95";
    } else {
      displayedMark = `${atar} to ${atar + 4}`;
    }
    marks[atar] = <div className="slider-mark-value">{displayedMark}</div>;
    return marks;
  };

  render() {
    const { atar } = this.props;
    const { lowAtar } = this.state;
    return (
      // hidden so label does not overflow
      <section className="section" style={{ overflow: "hidden" }}>
        <h2 className="section-card-title" tabIndex={0}>
          3. Your ATAR
        </h2>
        <p>Indicate your ATAR (or estimated ATAR) range</p>
        {this.props.knowAtar ? (
          <div>
            <Input
              value={atar}
              aria-label="Enter your ATAR"
              size="large"
              className="custom-input"
              placeholder={"Enter Your ATAR"}
              onChange={this.onInputChange}
            />
            {lowAtar && (
              <Alert
                type="warning"
                message={`If your ATAR is 'less than ${MIN_ATAR}', enter ${MIN_ATAR}.`}
                style={{ marginTop: 20 }}
              />
            )}
          </div>
        ) : (
          <div id="select-atar-slider">
            <Slider
              marks={this.getMarks()}
              value={Number(atar)}
              min={26}
              max={96}
              step={5}
              onChange={this.onSliderChange}
              tipFormatter={false}
            />
          </div>
        )}
      </section>
    );
  }
}

const mapStateToProps = (store) => {
  const { atar } = store.atarReducer;
  return {
    knowAtar: store.selectStateReducer.knowAtar,
    atar: atar,
  };
};

export default connect(mapStateToProps)(SelectAtar);
